export default __webpack_public_path__ + "static/media/Search.d546e9c9.svg";